import clsx from 'clsx';
import { ReactComponent as Checksvg } from './check.svg';
import style from './style.module.scss';

export const Checkbox = ({ text, checked, onChange, fieldName }) => {
    return (
        <div className={style.block}>
            <div onClick={() => onChange(!checked, fieldName)} className={style.checkbox}>
                <Checksvg className={clsx(style.checksvg, checked && style.checked)} />
            </div>
            <div className={style.text} dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
};
